import { isApiError } from '@dorixona/api'

/** «Азиз Каримов» → «АК» — для кружка в верхней строке. */
export function initials(name: string): string {
  return name
    .split(' ')
    .map((word) => word.slice(0, 1))
    .slice(0, 2)
    .join('')
    .toUpperCase()
}

/**
 * Пять неверных паролей подряд закрывают вход на 15 минут (`account_locked`,
 * 423). Сброс пароля в карточке сотрудника снимает блокировку сразу.
 */
export const LOCKED_TEXT =
  'Пять неверных паролей подряд — вход закрыт на 15 минут. Подождите или попросите супер-админа сбросить пароль: сброс снимает блокировку'

/** Блокировка — не ошибка ввода: её показываем предупреждением, а не красным. */
export function isLocked(error: unknown): boolean {
  return isApiError(error) && error.code === 'account_locked'
}

/**
 * Сообщение о неудачном входе. Неизвестный логин и неверный пароль
 * показываются одинаково: иначе форма подсказывает, какие логины существуют
 * (docs/frontend/README.md §Admin).
 */
export function loginErrorText(error: unknown): string {
  const code = isApiError(error) ? error.code : 'network'
  switch (code) {
    case 'invalid_credentials':
      return 'Неверный логин или пароль'
    case 'account_locked':
      return LOCKED_TEXT
    case 'validation_failed':
      return 'Заполните логин и пароль'
    case 'rate_limited':
      return 'Слишком часто. Подождите минуту и попробуйте снова'
    default:
      return 'Сервер недоступен. Проверьте соединение и попробуйте снова'
  }
}

/** Сообщение о неудачной смене пароля. */
export function passwordErrorText(error: unknown): string {
  const code = isApiError(error) ? error.code : 'network'
  switch (code) {
    case 'invalid_credentials':
      return 'Временный пароль не подошёл. Введите его ещё раз'
    case 'validation_failed':
      return 'Новый пароль — не короче 8 символов и не такой же, как старый'
    default:
      return 'Сервер недоступен. Проверьте соединение и попробуйте снова'
  }
}

/**
 * Пароль принимается с 8 символов и должен отличаться от старого. Повтор
 * ловит опечатку: с ней сотрудник не войдёт и пойдёт к супер-админу.
 */
export function passwordProblem(
  oldPassword: string,
  newPassword: string,
  repeat: string,
): string | null {
  if (!oldPassword) return 'Введите временный пароль'
  if (newPassword.length < 8) return 'Новый пароль — не короче 8 символов'
  if (newPassword === oldPassword) return 'Новый пароль должен отличаться от текущего'
  if (repeat !== newPassword) return 'Пароли не совпадают'
  return null
}
